import React, { useRef, useEffect, useState } from 'react';
import { ChunkLayout } from './';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
  addBookmark,
  removeBookmark
} from '../../../redux/actions/BookmarksActions';
import { lastChunkLoaded } from '../../../redux/actions/ChunkActions';
import { useTranslation } from 'react-i18next';
import CmsTools from '../../CmsTools/CmsTools';
import useXapi from '../../../Hooks/useXapi';
import './Chunk.scss';

const Chunk = props => {
  const { xApiEvent } = useXapi();
  const dispatch = useDispatch();
  const chunkRef = useRef();
  const { uuid, layout, title } = props;
  const { currentStep, courseId, bookmarks } = useSelector(
    state => ({
      currentStep: state.CourseState.currentStep,
      courseId: state.CourseState.courseId,
      bookmarks: state.BookmarksState.bookmarks
    }),
    shallowEqual
  );

  const { t } = useTranslation();
  const isHomepage = courseId === currentStep.li;
  const { chunks } = currentStep;
  let isBookmarked;
  let isLastChunk;
  let chunkLi;
  let currentChunk;

  if (!isHomepage) {
    currentChunk = chunks.find(c => c.id === uuid);
    chunkLi = currentChunk.li;
    // checks this LI for bookmarks in the course
    isBookmarked = bookmarks[courseId]
      ? bookmarks[courseId].list.includes(chunkLi)
      : false;
    isLastChunk = chunks.indexOf(currentChunk) === chunks.length - 1;
  } else {
    chunkLi = courseId;
  }

  const [isLastchunkLoaded, setIsLastChunkLoaded] = useState(false);

  useEffect(() => {
    if (!isHomepage) {
      // save dom refs so we can scroll to them without having to look them up.
      if (isLastChunk && !isLastchunkLoaded) {
        dispatch(lastChunkLoaded());
        setIsLastChunkLoaded(true);
      }
    }
  }, [isHomepage, dispatch, isLastChunk, isLastchunkLoaded]);

  return (
    <div
      ref={chunkRef}
      id={`chunk-${chunkLi}`}
      className={`chunk chunk-container`}
    >
      <CmsTools id={uuid} type="chunks" />
      {!isHomepage && (
        <div className="bookmark-chunk">
          <button
            aria-label={`${
              isBookmarked
                ? `${t('Chunk.removeBookmarkFor')} ${chunkLi} ${
                    currentChunk.name
                  }`
                : `${t('Chunk.bookmark')} ${chunkLi} ${currentChunk.name}`
            }`}
            className={`btn btn--icon btn--small btn--secondary bookmark-btn ${
              isBookmarked ? 'is-bookmarked' : ''
            }`}
            onClick={() => {
              if (isBookmarked) {
                xApiEvent(
                  `${chunkLi} is removed from bookmark.`,
                  window.location.href
                );
                dispatch(removeBookmark(`${chunkLi}`));
              } else {
                xApiEvent(`${chunkLi} is bookmarked.`, window.location.href);
                dispatch(addBookmark(`${chunkLi}`));
              }
            }}
          >
            <span className="icon-bookmark"></span>
          </button>
        </div>
      )}
      <div className="container">
        {currentChunk && (
          <div className="current-li label label--small">{currentChunk.li}</div>
        )}
        <ChunkLayout header={title} layout={layout}>
          {props.children}
        </ChunkLayout>
      </div>
    </div>
  );
};

export default Chunk;
